require('rc-slider/assets/index.css');
import React, {PropTypes} from 'react';
import ReactDOM from 'react-dom';
import RCSlider from 'rc-slider';
import {formatMoney} from '../../lib/utils';
import {__} from '../../../server/lib/i18n-2/browserHelper'

let styles = {
  wrapper: {
    width: '40rem', position:'relative',
  },
  pointer: {
    position: 'absolute',
    top: '2rem',
    color: '#1EC2EB',
  },
}
styles = {
  ...styles,
  rightPointer: {
    ...styles.pointer,
    right: 0
  },
  leftPointer: {
    ...styles.pointer,
    left: 0
  },
  color: {
    background: 'red',
  }
}

export default class Slider extends React.Component {
  constructor(props) {
    super(props)
    const initialStep = (Math.round(Math.sqrt(Math.abs(props.maxValue)))/30)
    this.state = {
      value: [props.negativeInfinity ? -initialStep : 0, Math.round(this.preload(props.maxValue))+initialStep]
    }
  }

  onSliderChange(value, {negativeInfinityValue, positiveInfinityValue}) {
    this.setState({
      value,
    });
    const min = value[0] !== negativeInfinityValue && this.roundMillions(this.postload(value[0]))
    let max = value[1] !== positiveInfinityValue && this.roundMillions(this.postload(value[1]))
    value[1] === negativeInfinityValue ? max = 0 :

    this.props.handleChange({min, max})
  }

  roundMillions(value) {
    if(value > 10*1000*1000)
      return Math.round(value/1000000)*1000000
    else if(value > 1000*1000)
      return Math.round(value/100000)*100000
    else
      return Math.round(value/10000)*10000
  }

  preload(value) {
    return Math.sqrt(Math.abs(value))
  }

  postload(value) {
    return Math.pow(value, 2)
  }

  render() {
    const {props: {negativeInfinity, positiveInfinity, maxValue}} = this
    const sourceMaxValue = Math.round(this.preload(maxValue))

    // tyhle veci nakonec patrej sem, protoze se upravuji pri kazdym renderu
    // (neco nam muze zmenit props a potrebujeme je prepocitat) TODO: po precteni smazat
    const step = sourceMaxValue/30
    const negativeInfinityValue = - step
    const positiveInfinityValue = sourceMaxValue + step
// lepsi citelnost kodu TODO: po precteni smazat tento koment
    const currentLeft = this.state.value[0]
    const currentRight = this.state.value[1]

    if (!this.state.alreadyLoaded) {
      this.onSliderChange([currentLeft, currentRight], {negativeInfinityValue, positiveInfinityValue})
      this.setState({alreadyLoaded: true})
    }

    const leftPointerText =
      currentLeft === negativeInfinityValue && negativeInfinity &&
       __('Záporná') ||
      formatMoney(this.roundMillions(this.postload(currentLeft)))
    let rightPointerText
    if (currentRight === positiveInfinityValue && positiveInfinity) {
      rightPointerText = __('Neomezeně')
    } else if (currentRight === negativeInfinityValue && negativeInfinity) {
      rightPointerText = __('Záporná')
    } else {
      rightPointerText = formatMoney(this.roundMillions(this.postload(currentRight)))
    }

    return (
      <div className="baseline" style={styles.wrapper}>
        <RCSlider
          tipFormatter={null}
          range
          step={step}
          min={negativeInfinity ? negativeInfinityValue : 0}
          max={positiveInfinity ? positiveInfinityValue : sourceMaxValue}
          allowCross={false}
          value={this.state.value}
          onChange={(val) => this.onSliderChange(val, {negativeInfinityValue, positiveInfinityValue})}
        />
      <div style={styles.leftPointer}>{leftPointerText}</div>
        <div style={styles.rightPointer}>{rightPointerText}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/smart/Slider.react.js